import { createSlice } from '@reduxjs/toolkit'

const initialState = { value: false, msg: '', type: 'info' }

const toastSlice = createSlice({
	name: 'toast',
	initialState,
	reducers: {
		showToast(state, { payload }) {
			state.value = true
			state.msg = payload.msg
			state.type = payload.type || 'info'
		},
		hideToast(state) {
			state.value = false
			state.msg = ''
			state.type = 'info'
		}
	}
})

export const { showToast, hideToast } = toastSlice.actions
export default toastSlice.reducer